import {
  _primaryControls,
  _selectorControls,
  _increment,
  status,
  createdAt,
  name,
  amount,
  createdBy,
  sortable,
} from './base';

export default {
  types: {
    _primaryControls,
    _selectorControls,
    _increment,
    status,
    createdAt,
    // eslint-disable-next-line
    payment_account_id: {
      name: 'รหัสบัญชี',
      width: '6rem',
      filter: (val: any, row: any) => row.item.account.code,
    },
    'account.name': {
      name: 'หมวดหมู่',
      width: '10rem',
    },
    name,
    amount,
    createdBy,
  },
  sortable,
};
